module.exports = __webpack_public_path__ + "img/checked.47d90f2c.svg";